module.exports = __webpack_public_path__ + "static/media/fish.2ac5ecf6.jpg";